var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "deliveriesModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal del-modal",
            title: "MMP Deliveries",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.getDeliveries()
            },
          },
        },
        [
          _vm._l(_vm.regions, function (region, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "form-check form-check-inline checkbox-group",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.checkedNames,
                      expression: "checkedNames",
                    },
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "region-" + index },
                  domProps: {
                    value: region,
                    checked: Array.isArray(_vm.checkedNames)
                      ? _vm._i(_vm.checkedNames, region) > -1
                      : _vm.checkedNames,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.checkedNames,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = region,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.checkedNames = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.checkedNames = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.checkedNames = $$c
                        }
                      },
                      _vm.handleCheckboxChange,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "region-" + index },
                  },
                  [_vm._v(_vm._s(region))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("vue-bootstrap4-table", {
            attrs: {
              rows: _vm.deliveryRows,
              columns: _vm.columns,
              config: _vm.config,
              actions: _vm.actions,
              classes: _vm.classes,
            },
            on: {
              downloadCSV: function ($event) {
                return _vm.downloadCSV()
              },
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }